import ChildrenEntities from 'publisher/components/ChildrenEntities'
import React, { memo } from 'react'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'
import { CommonWebsiteFooter } from 'src/shared/entities/website-footer'
import { WebsiteFooterInterface } from 'src/shared/types/website-entities'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'

export interface WebsiteFooterProps {
  entity: WebsiteFooterInterface
}

export const WebsiteFooter = memo(({ entity }: WebsiteFooterProps) => {
  const { headerAndFooter } = useThemeColor()
  const backgroundImage = getBackgroundImageStyleValue(
    headerAndFooter?.footerBackgroundPicture.file,
  )

  return (
    <CommonWebsiteFooter
      htmlAttrId={entity.htmlAttrId}
      backgroundImage={backgroundImage}
      background={headerAndFooter?.footerBackgroundPicture.background}
      backgroundColor={headerAndFooter?.footerBackgroundColor}
      border={entity.border}
      mobileBorder={entity.mobileBorder}
      padding={entity.padding}
      mobilePadding={entity.mobilePadding}
      contentWidth={entity.contentWidth}
    >
      <ChildrenEntities childIds={entity.childIds} />
    </CommonWebsiteFooter>
  )
})
